// Library Card Action Types
export const FETCH_LIBRARY_CARDS_REQUEST = "FETCH_LIBRARY_CARDS_REQUEST";
export const FETCH_LIBRARY_CARDS_SUCCESS = "FETCH_LIBRARY_CARDS_SUCCESS";
export const FETCH_LIBRARY_CARDS_FAILURE = "FETCH_LIBRARY_CARDS_FAILURE";

export const CREATE_LIBRARY_CARD_REQUEST = "CREATE_LIBRARY_CARD_REQUEST";
export const CREATE_LIBRARY_CARD_SUCCESS = "CREATE_LIBRARY_CARD_SUCCESS";
export const CREATE_LIBRARY_CARD_FAILURE = "CREATE_LIBRARY_CARD_FAILURE";

export const UPDATE_LIBRARY_CARD_REQUEST = "UPDATE_LIBRARY_CARD_REQUEST";
export const UPDATE_LIBRARY_CARD_SUCCESS = "UPDATE_LIBRARY_CARD_SUCCESS";
export const UPDATE_LIBRARY_CARD_FAILURE = "UPDATE_LIBRARY_CARD_FAILURE";

export const DELETE_LIBRARY_CARD_REQUEST = "DELETE_LIBRARY_CARD_REQUEST";
export const DELETE_LIBRARY_CARD_SUCCESS = "DELETE_LIBRARY_CARD_SUCCESS";
export const DELETE_LIBRARY_CARD_FAILURE = "DELETE_LIBRARY_CARD_FAILURE";

// File Upload (Presigned URL Flow)
export const REQUEST_PRESIGNED_URL = "REQUEST_PRESIGNED_URL";
export const PRESIGNED_URL_SUCCESS = "PRESIGNED_URL_SUCCESS";
export const PRESIGNED_URL_FAILURE = "PRESIGNED_URL_FAILURE";

export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";

// Metadata Operations
export const FETCH_METADATA_REQUEST = "FETCH_METADATA_REQUEST";
export const FETCH_METADATA_SUCCESS = "FETCH_METADATA_SUCCESS";
export const FETCH_METADATA_FAILURE = "FETCH_METADATA_FAILURE";

// Listing and Managing Cards
export const LIST_CARDS_REQUEST = "LIST_CARDS_REQUEST";
export const LIST_CARDS_SUCCESS = "LIST_CARDS_SUCCESS";
export const LIST_CARDS_FAILURE = "LIST_CARDS_FAILURE";

export const FETCH_CARD_DETAILS_REQUEST = "FETCH_CARD_DETAILS_REQUEST";
export const FETCH_CARD_DETAILS_SUCCESS = "FETCH_CARD_DETAILS_SUCCESS";
export const FETCH_CARD_DETAILS_FAILURE = "FETCH_CARD_DETAILS_FAILURE";

// Marketing Prompt Action Types
export const FETCH_MARKETING_RESPONSE_REQUEST =
  "FETCH_MARKETING_RESPONSE_REQUEST";
export const FETCH_MARKETING_RESPONSE_SUCCESS =
  "FETCH_MARKETING_RESPONSE_SUCCESS";
export const FETCH_MARKETING_RESPONSE_FAILURE =
  "FETCH_MARKETING_RESPONSE_FAILURE";

// New Action Types for Prompt Submission
export const SUBMIT_PROMPT_REQUEST = "SUBMIT_PROMPT_REQUEST";
export const SUBMIT_PROMPT_SUCCESS = "SUBMIT_PROMPT_SUCCESS";
export const SUBMIT_PROMPT_FAILURE = "SUBMIT_PROMPT_FAILURE";

// Serialized Code Submission
export const SUBMIT_SERIALIZED_CODE_REQUEST = "SUBMIT_SERIALIZED_CODE_REQUEST";
export const SUBMIT_SERIALIZED_CODE_SUCCESS = "SUBMIT_SERIALIZED_CODE_SUCCESS";
export const SUBMIT_SERIALIZED_CODE_FAILURE = "SUBMIT_SERIALIZED_CODE_FAILURE";

// Startup Folder Creation
export const INITIATE_STARTUP_CREATION = "INITIATE_STARTUP_CREATION";
export const STARTUP_CREATION_SUCCESS = "STARTUP_CREATION_SUCCESS";
export const STARTUP_CREATION_FAILURE = "STARTUP_CREATION_FAILURE";

// App Publish
export const INITIATE_PUBLISH_NOW = "INITIATE_PUBLISH_NOW";
export const PUBLISH_NOW_SUCCESS = "PUBLISH_NOW_SUCCESS";
export const PUBLISH_NOW_FAILURE = "PUBLISH_NOW_FAILURE";

// Publishing Page Layout
export const INITIATE_PUBLISH_PAGE_LAYOUT = "INITIATE_PUBLISH_PAGE_LAYOUT";
export const PUBLISH_PAGE_LAYOUT_SUCCESS = "PUBLISH_PAGE_LAYOUT_SUCCESS";
export const PUBLISH_PAGE_LAYOUT_FAILURE = "PUBLISH_PAGE_LAYOUT_FAILURE";

// Publishing Menu Layout
export const INITIATE_PUBLISH_MENU_LAYOUT = "INITIATE_PUBLISH_MENU_LAYOUT";
export const INITIATE_PUBLISH_LANDING_PAGE_LAYOUT =
  "INITIATE_PUBLISH_LANDING_PAGE_LAYOUT";
export const PUBLISH_MENU_LAYOUT_SUCCESS = "PUBLISH_MENU_LAYOUT_SUCCESS";
export const PUBLISH_MENU_LAYOUT_FAILURE = "PUBLISH_MENU_LAYOUT_FAILURE";
